import { GlobalConfigType, setApplicationStep } from 'actions'
import cloneDeep from 'clone-deep'
import { LoanFieldProps } from 'config'
import { store } from 'reducers'

import { BorrowerSeperator } from '../config'
import { borrowerMenuKey } from '../util'

export const additionalMemberValidate = (borrowerSeperator: BorrowerSeperator, updateStore = false) => {
  const { step, globalConfigReducer, borrower } = store.getState()
  const hasAdditionalMember = borrower[borrowerSeperator]?.hasAdditionalMember
  const dataLength = borrower[borrowerSeperator]?.additionalMembers?.length
  const loanFieldProperties = globalConfigReducer[GlobalConfigType.LoanFields] as LoanFieldProps
  if (((loanFieldProperties as any)['visibility'] || {})['additionalMember'] === false) {
    return true
  }

  let success = true
  if (hasAdditionalMember === undefined || hasAdditionalMember === null) success = false
  else if (hasAdditionalMember === true) {
    if (dataLength === 0) {
      success = false
    }
  }
  if (updateStore) {
    let application = cloneDeep(step.application)
    const key = borrowerMenuKey(borrowerSeperator, 'additionalMember')
    application[key] = success ? 1 : -1
    store.dispatch(setApplicationStep(application))
  }
  return success
}
